export function injectSprinklrScript() {
   
  ;(function () {
    const t = window,
      e = t.sprChat,
      a = e && !!e.loaded,
      n = document,
      r = function (...args) {
        r.m(args)
      }
    ;(r.q = []),
      (r.m = function (t) {
        r.q.push(t)
      }),
      (t.sprChat = a ? e : r)
    const e2 = t.sprTeamChat,
      r2 = function (...args) {
        r2.m(args)
      }
    ;(r2.q = []),
      (r2.m = function (t) {
        r2.q.push(t)
      }),
      (t.sprTeamChat = e2 ? e2 : r2)
    const o = function () {
      const e = n.createElement('script')
      ;(e.type = 'text/javascript'),
        (e.async = !0),
        (e.src =
          'https://prod2-live-chat.sprinklr.com/api/livechat/handshake/widget/' +
          t.sprChatSettings.appId)
      ;(e.onerror = function () {
        t.sprChat.loaded = !1
      }),
        (e.onload = function () {
          t.sprChat.loaded = !0
        })
      const a = n.getElementsByTagName('script')[0]
      a.parentNode.insertBefore(e, a)
    }
    'function' == typeof e
      ? a
        ? e('update', t.sprChatSettings)
        : o()
      : 'loading' !== n.readyState
      ? o()
      : n.addEventListener('DOMContentLoaded', o)
  })()
}
